export const LOADING_FORM_RESPONSES = "LOADING_FORM_RESPONSES";
export const SAVE_LOADING_FORM_RESPONSES = "SAVE_LOADING_FORM_RESPONSES";
export const GET_FORM_RESPONSES = "GET_FORM_RESPONSES";
export const CREATE_FORM_RESPONSE = "CREATE_FORM_RESPONSE";
export const GET_EMPLOYEE_FORM = "GET_EMPLOYEE_FORM";
export const GET_FORM_QUESTIONS = "GET_FORM_QUESTIONS";
export const CREATE_FORM_QUESTION = "CREATE_FORM_QUESTION";
export const EDIT_FORM_QUESTION = "EDIT_FORM_QUESTION";
export const CHANGE_QUESTION_STATUS = "CHANGE_QUESTION_STATUS";
export const FORM_RESPONSES_FAIL = "FORM_RESPONSES_FAIL";
export const FORM_RESPONSES_FORM_FAIL = "FORM_RESPONSES_FORM_FAIL";
export const CLEAR_FORM_RESPONSES = "CLEAR_FORM_RESPONSES";